import { render, staticRenderFns } from "./link-info.vue?vue&type=template&id=5825ad16"
import script from "./link-info.vue?vue&type=script&lang=js"
export * from "./link-info.vue?vue&type=script&lang=js"
import style0 from "./link-info.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/link/link-info.vue
// module id = YYxp
// module chunks = 0